<template>
  <v-form v-on:submit.prevent='submitForm(formData)'>
    <v-card flat>
      <v-card-text>
        <p>Add one or several users. To add several users, separate the email addresses using comma</p>
        <v-row>
          <v-col cols="12" sm="8">
            <v-textarea
              :disabled="loading || disabled"
              data-vv-name="email"
              v-model="formData.email"
              label="Email"
              rows="1" auto-grow
              @input="validate"
              :error-messages="errorMessage"
              validate-on-blur
            />
          </v-col>
          <v-col cols="12" sm="4">
            <v-btn type='submit' :disabled="!valid || loading || disabled" large class="add white--text mx-0" >
              {{ buttonText }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-form>
</template>

<script>
export default {
  name: 'EmailForm',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    buttonText: {
      type: String,
      default: 'Button Text'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data: function () {
    return {
      valid: false,
      formData: {
        email: ''
      }
    }
  },

  methods: {
    validate () {
      let emails = this.formData.email
      let regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (emails.length === 0) {
        this.valid = false
      } else if (emails && emails.includes(',')) {
        let validEmails = true
        let emailList = emails.split(',')
        for (let i = 0; i < emailList.length; i++) {
          if (!regex.test(emailList[i].trim())) {
            validEmails = false
          }
        }
        this.valid = validEmails
      } else {
        let validEmail = regex.test(emails.trim())
        this.valid = validEmail
      }
    },

    submitForm: function (formData) {
      if (this.valid) {
        this.$emit('submit-form', formData)
      }
    },

    resetData: function () {
      this.formData = {
        email: ''
      }
      this.valid = false
    }
  },

  computed: {
    errorMessage: function () {
      if (this.formData.email.length === 0) {
        return ''
      } else {
        return this.valid ? '' : 'Must be an valid email'
      }
    }
  }
}
</script>

<style scoped>

</style>
